import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { keyframes } from '@emotion/react'

const shimmerAnimation = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`

export const LoadingTitle = styled.div({
  boxSizing: 'border-box',
  height: '1.375rem',
  width: '95%',
  marginBottom: tokens.spacing[6],
  position: 'relative',
  backgroundColor: tokens.color.airJordan[200],
  overflow: 'hidden',

  '&:after': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(90deg,rgba(204, 204, 204, 0) 0%,rgba(202, 202, 202, 0.599) 54.57%,rgba(196, 196, 196, 0) 100%)',
    transform: 'translateX(100%)',
    animation: `${shimmerAnimation} 2s infinite`
  }
})

export const LoadingText = styled.div({
  boxSizing: 'border-box',
  height: '3rem',
  marginBottom: tokens.spacing[6],
  position: 'relative',
  backgroundColor: tokens.color.airJordan[200],
  overflow: 'hidden',

  '&:after': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(90deg,rgba(204, 204, 204, 0) 0%,rgba(202, 202, 202, 0.599) 54.57%,rgba(196, 196, 196, 0) 100%)',
    transform: 'translateX(100%)',
    animation: `${shimmerAnimation} 2s infinite`
  }
})
